import React from 'react';
import Row from '../../../../components/tag/Row';
import Span from '../../../../components/tag/Span';
import biopankkiLogo from '../../../../images/biobankki-logo-transparent.png';
import { FormattedMessage } from 'react-intl';

const BiobankLaboratoryInfo = ({ theme }) => {
  return (
    <div
      className={`ot-notification__biobank-info ot-notification__biobank-info--${theme}`}
    >
      <Row>
        <Span len={3}>
          <img src={biopankkiLogo} />
        </Span>
        <Span len={9}>
          <FormattedMessage id={'fimlab.biobank.info'} />
        </Span>
      </Row>
    </div>
  );
};

export default BiobankLaboratoryInfo;
